import { reauthenticateForSensitiveAction } from "./sensitiveReauthentication";

export async function requestProviderAwareDataExport({
  firebaseUser,
  password = "",
  language,
  requestExport,
  reauthenticate = reauthenticateForSensitiveAction,
} = {}) {
  const reauthResult = await reauthenticate({ firebaseUser, password });
  if (reauthResult?.cancelled) {
    return { cancelled: true, exportRequested: false };
  }

  if (typeof firebaseUser?.getIdToken !== "function") {
    throw new Error("Firebase ID token refresh is unavailable.");
  }
  await firebaseUser.getIdToken(true);

  const result = await requestExport({ language });
  return {
    cancelled: false,
    exportRequested: true,
    result,
    method: reauthResult?.method,
  };
}
